<template>
  <div class="sectionIndex" id="index" ref="indexRef">
    <div class="main">
      <div class="slogan limit-px" v-if="slogan" :style="{ 'background-image': `url(${slogan})` }">
        <VideoPlay></VideoPlay>
      </div>
      <DownloadBox></DownloadBox>
    </div>
    <div class="bgm"
         v-if="bgm"
         :class="{paused: !audioState}"
         @click="audioState = !audioState"
    >
      <audio
          :src="bgm"
          ref="audioRef"
          loop
          autoplay="autoplay"
      ></audio>
    </div>
    <SocialWrap></SocialWrap>
  </div>
</template>

<script setup lang="ts">
import DownloadBox from '@/components/index/DownloadBox.vue';
import VideoPlay from '@/components/index/VideoPlay.vue';
import SocialWrap from '@/components/index/SocialWrap.vue';
import indexHook from '@/hooks/indexHook';
const { indexRef, bgm, audioState, audioRef, slogan } = indexHook();
</script>
